import type { StylesConfig } from 'react-select';
import { VirtualizedMenuList } from './VirtualizedMenuList';
import {
  TooltipOption,
  TooltipSingleValue,
  type RuleSelectOption,
} from './ruleSelectComponents';

export const clipOption = <T>(base: T) => ({
  ...base,
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden' as const,
  textOverflow: 'ellipsis' as const,
});

export const ruleSelectStyles: StylesConfig<RuleSelectOption, false> = {
  control: (base, state) => ({
    ...base,
    height: 32,
    minHeight: 32,
    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
    '&:hover': { borderColor: state.isFocused ? '#3b82f6' : '#9ca3af' },
  }),
  valueContainer: (base) => ({ ...base, padding: '0 8px' }),
  indicatorsContainer: (base) => ({ ...base, height: 32, padding: '0 2px' }),
  indicatorSeparator: () => ({ display: 'none' }),
  option: (base) => ({ ...clipOption(base), fontSize: '0.75rem' }),
  singleValue: (base) => ({ ...clipOption(base), fontSize: '0.75rem' }),
  placeholder: (base) => ({ ...base, fontSize: '0.75rem' }),
  input: (base) => ({ ...base, fontSize: '0.75rem' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export const ruleSelectComponents = {
  MenuList: VirtualizedMenuList,
  Option: TooltipOption,
  SingleValue: TooltipSingleValue,
};
